import has from 'lodash/has';
import { connect } from 'react-redux';
import { RESOURCE_TYPE_DATA_SET } from '../../../constants/resourceTypes';
import { isAdminAccess, isManagedResource, isReadOnly } from '../../../lib/ACLUtils';
import { getConnectionOrVendorType, isDetectedDataset } from '../../../lib/ResourceUtils';
import DataSetCard from './DataSetCard';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { dataSets, users, sources, vendors, flowNodes, transforms },
    paging: { metaInfoById },
    metrics,
    pipelines: { parentRelationships },
  } = state;
  const { cardData, toggleUseExpanded } = ownProps;
  const metric = has(metrics[RESOURCE_TYPE_DATA_SET], cardData.id)
    ? metrics[RESOURCE_TYPE_DATA_SET][cardData.id]
    : null;
  const entity = dataSets[cardData.id];
  const data = { ...cardData, ...entity };

  const flow = flowNodes[data.origin_node_id];
  const flowType = data?.flow_type || flow?.flow_type;

  const readOnly = isReadOnly(data);
  const isManaged = isManagedResource(data);
  const adminAccess = isAdminAccess(data);
  const isDetected = isDetectedDataset(cardData);

  let owner = null;
  if (has(data, 'owner_id') && has(users, data.owner_id)) {
    owner = users[data.owner_id];
  } else if (has(data, 'owner') && has(users, data.owner)) {
    owner = users[data.owner];
  }
  const source =
    isDetected === true && data && has(data, 'data_source_id')
      ? sources[data.data_source_id]
      : null;
  let connectionInfo = null;

  if (source) {
    const connectionOrVendorType = getConnectionOrVendorType(
      source,
      vendors,
      'source_type',
      'vendor_id',
    );

    connectionInfo =
      metaInfoById && has(metaInfoById, connectionOrVendorType)
        ? metaInfoById[connectionOrVendorType]
        : null;
  }

  let root = source;

  if (!root) {
    let rootKey;

    for (
      rootKey = cardData.nodeKey;
      rootKey && flowNodes[rootKey] && flowNodes[rootKey].depth !== 0;
      rootKey = parentRelationships[rootKey]
    );

    if (rootKey && flowNodes[rootKey]?.type === 'SOURCE') {
      root = sources[flowNodes[rootKey].data_source_id];
    }
  }

  let rootConnectionInfo = null;

  if (root) {
    const connectionOrVendorType = getConnectionOrVendorType(
      root,
      vendors,
      'source_type',
      'vendor_id',
    );

    rootConnectionInfo =
      metaInfoById && has(metaInfoById, connectionOrVendorType)
        ? metaInfoById[connectionOrVendorType]
        : null;
  }

  return {
    flowType,
    connectionInfo,
    data,
    readOnly,
    isManaged,
    adminAccess,
    owner,
    transforms,
    rootConnectionInfo,
    metric,
    isLoading: {
      metric: request.GET_FLOW_METRICS_REQUEST || false,
    },
    toggleUseExpanded,
  };
};

export default connect(mapStateToProps)(DataSetCard);
